import { useState } from 'react'
import { changePassword, auth } from '../lib/api.js'
import { useNavigate } from 'react-router-dom'
import { alertBox } from './Dialog.jsx'

export default function ChangePassword({ onClose }) {
  const nav = useNavigate()
  const [oldPw, setOldPw] = useState('')
  const [newPw, setNewPw] = useState('')
  const [confirm, setConfirm] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit() {
    setErr('')
    if (newPw.length < 8) return setErr('新密码至少 8 位')
    if (newPw !== confirm) return setErr('两次输入的新密码不一致')
    setBusy(true)
    try {
      await changePassword(oldPw, newPw)
      await alertBox('密码已修改，请重新登录')
      auth.clear()
      nav('/login', { replace: true })
    } catch (e) {
      setErr(e.message); setBusy(false)
    }
  }

  return (
    <div className="modal-bg" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <h2>修改密码</h2>
        <div className="field">
          <label>原密码</label>
          <input className="input" type="password" value={oldPw} onChange={e => setOldPw(e.target.value)} />
        </div>
        <div className="field">
          <label>新密码</label>
          <input className="input" type="password" value={newPw} onChange={e => setNewPw(e.target.value)} placeholder="至少 8 位" />
        </div>
        <div className="field">
          <label>确认新密码</label>
          <input className="input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                 onKeyDown={e => e.key === 'Enter' && submit()} />
        </div>
        <div className="err">{err}</div>
        <div className="row" style={{ justifyContent: 'flex-end', marginTop: 8 }}>
          <button className="btn" onClick={onClose}>取消</button>
          <button className="btn btn-primary" onClick={submit} disabled={busy}>确定</button>
        </div>
      </div>
    </div>
  )
}
